import React, { useState, useEffect } from "react";
import Tippy from "@tippyjs/react";
import Flatpickr from "react-flatpickr";
import InputField from "../../../component/input-field";
import Select from "react-select";
import "../../../css/theme.css";
import "flatpickr/dist/flatpickr.css";

export const TextField = (props) => {
  const { componentParameter, setComponentParameter, isSelected } = props;

  return (
    <InputField
      type="text"
      label={
        componentParameter.componentName
          ? componentParameter.componentName
          : "Component Name"
      }
      wrapperClass="w-full"
      labelClass={`w-full overflow-hidden truncate cursor-pointer ${
        isSelected && "text-white"
      } ${componentParameter.isDisabled && "text-slate-300"}`}
      placeholder={
        componentParameter.componentPlaceholder
          ? componentParameter.componentPlaceholder
          : "Component Placeholder"
      }
      value={
        componentParameter?.previewValue ? componentParameter?.previewValue : ""
      }
      onChange={(e) => {
        if (setComponentParameter) {
          setComponentParameter({
            ...componentParameter,
            previewValue: e.target.value,
          });
        }
      }}
      required={componentParameter.isMandatory}
      tooltip={componentParameter.componentTooltip}
      tooltipClass={`${isSelected ? "text-white" : "text-[--bg-color-500]"}`}
    />
  );
};

export const NumberField = (props) => {
  const { componentParameter, setComponentParameter, isSelected } = props;

  return (
    <InputField
      type="number"
      label={
        componentParameter.componentName
          ? componentParameter.componentName
          : "Component Name"
      }
      wrapperClass="w-full"
      labelClass={`w-full overflow-hidden truncate ${
        isSelected && "text-white"
      } ${componentParameter.isDisabled && "text-slate-300"}`}
      placeholder={
        componentParameter.componentPlaceholder
          ? componentParameter.componentPlaceholder
          : "Component Placeholder"
      }
      required={componentParameter.isMandatory}
      tooltip={componentParameter.componentTooltip}
      tooltipClass={`${isSelected ? "text-white" : "text-[--bg-color-500]"}`}
      value={
        componentParameter?.previewValue ? componentParameter?.previewValue : ""
      }
      onChange={(e) => {
        if (setComponentParameter) {
          setComponentParameter({
            ...componentParameter,
            previewValue: e.target.value,
          });
        }
      }}
    />
  );
};

export const Paragraph = (props) => {
  const { componentParameter, setComponentParameter, isSelected, calledFrom } =
    props;
  return (
    <div className="w-full">
      <div
        className={`flex items-center ${
          !calledFrom && "justify-between"
        } space-x-3`}
      >
        <label
          className={`block text-sm font-medium mb-1 w-full overflow-hidden truncate ${
            isSelected && "text-white"
          } ${componentParameter.isDisabled && "text-slate-300"}`}
          title={
            componentParameter.componentName
              ? componentParameter.componentName
              : "Component Name"
          }
        >
          {componentParameter.componentName
            ? componentParameter.componentName
            : "Component Name"}
          &nbsp;
          {!componentParameter.isMandatory ? null : (
            <span className="text-rose-500">*</span>
          )}
        </label>
        {!componentParameter.componentTooltip ? null : (
          <Tippy
            content={componentParameter.componentTooltip}
            className="break-words"
          >
            <span
              className={`fas fa-info-circle fill-current ${
                isSelected ? "text-white" : "text-[--bg-color-500]"
              }  cursor-pointer text-sm ${calledFrom && "absolute right-11"}`}
            ></span>
          </Tippy>
        )}
      </div>

      <div className="relative">
        <textarea
          rows="2"
          className="w-full form-textarea resize-none"
          placeholder={
            componentParameter.componentPlaceholder
              ? componentParameter.componentPlaceholder
              : "Component Placeholder"
          }
          value={
            componentParameter?.previewValue
              ? componentParameter.previewValue
              : ""
          }
          onChange={(e) => {
            if (setComponentParameter) {
              setComponentParameter({
                ...componentParameter,
                previewValue: e.target.value,
              });
            }
          }}
        ></textarea>
      </div>
    </div>
  );
};

export const Dropdown = (props) => {
  const {
    componentParameter,
    setComponentParameter,
    isSelected,
    dropdownOptions,
  } = props;

  return (
    <div className="w-full">
      <div className="flex items-center justify-between">
        <label
          className={`block text-sm font-medium mb-1 w-full overflow-hidden truncate ${
            isSelected && "text-white"
          } ${componentParameter?.isDisabled && "text-slate-300"}`}
          title={
            componentParameter.componentName
              ? componentParameter.componentName
              : "Component Name"
          }
        >
          {componentParameter.componentName
            ? componentParameter.componentName
            : "Component Name"}
          &nbsp;
          {!componentParameter.isMandatory ? null : (
            <span className="text-rose-500">*</span>
          )}
        </label>
        {!componentParameter.componentTooltip ? null : (
          <Tippy
            content={componentParameter.componentTooltip}
            className="break-words"
          >
            <span
              className={`fas fa-info-circle fill-current ${
                isSelected ? "text-white" : "text-[--bg-color-500]"
              }  cursor-pointer text-sm`}
            ></span>
          </Tippy>
        )}
      </div>

      <div className="relative">
        <Select
          options={
            dropdownOptions.filter((element, index) => element?.label).length >
            0
              ? dropdownOptions.filter((element, index) => element?.label)
              : []
          }
          isClearable={true}
          value={
            componentParameter?.previewValue
              ? componentParameter.previewValue
              : componentParameter?.listSelectedValue ? componentParameter.listSelectedValue : ""
          }
          onChange={(e) => {
            if (setComponentParameter) {
              setComponentParameter({
                ...componentParameter,
                listSelectedValue: e,
              });
            }
          }}
          menuPortalTarget={document.body}
          className="unresetText"
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
            placeholder: (provided, state) => ({
              ...provided,
              color: "#9B9B9B", // Set your desired color here
              fontSize: "14px",
            }),
          }}
          placeholder={
            componentParameter.componentPlaceholder
              ? componentParameter.componentPlaceholder
              : "Component Placeholder"
          }
          menuPlacement="auto"
        />
      </div>
      {/* {error ? null : (
          <div className="text-xs mt-1 text-rose-500">{props.error}!</div>
        )} */}
    </div>
  );
};

export const DateTime = (props) => {
  const { componentParameter, setComponentParameter, isSelected } = props;
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey((prevKey) => prevKey + 1);
  }, [componentParameter.componentPlaceholder]);

  const getDateTimePicker = (priorDate, futureDate) => {
    const options = {
      altFormat: "j M, Y H:i",
      dateFormat: "Y-m-d H:i",
      time_24hr: true,
      disableMobile: true,
      enableTime: true,
      altInput: true,
      minDate: priorDate ? null : new Date(),
      maxDate: futureDate ? null : new Date(),
    };

    return (
      <Flatpickr
        key={key}
        data-enable-time
        options={options}
        value={componentParameter?.previewValue || ""}
        onChange={(e) => {
          if (setComponentParameter) {
            setComponentParameter({
              ...componentParameter,
              previewValue: e[0],
            });
          }
        }}
        render={({ defaultValue }, ref) => {
          return (
            <div className="w-full">
              <input
                title={componentParameter.componentPlaceholder || "Component Placeholder"}
                className="form-input w-[100%] truncate disabled:border-slate-200"
                defaultValue={defaultValue}
                ref={ref}
                placeholder={componentParameter.componentPlaceholder || "Component Placeholder"}
              />
              <div className="absolute inset-0 left-auto flex items-center opacity-100 group">
                <span className="text-sm text-slate-500 font-medium px-3 ">
                  <span
                    className={`far fa-calendar ${componentParameter.isDisabled ? "text-slate-300" : "text-[#1E293B] z-60 bg-white"}`}
                  ></span>
                </span>
              </div>
            </div>
          );
        }}
      />
    );
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between">
        <label
          className={`block text-sm font-medium mb-1 w-full overflow-hidden truncate ${
            isSelected && "text-white"
          } ${componentParameter.isDisabled && "text-slate-300"}`}
          title={componentParameter.componentName || "Component Name"}
        >
          {componentParameter.componentName || "Component Name"}&nbsp;
          {componentParameter.isMandatory ? (
            <span className="text-rose-500">*</span>
          ) : null}
        </label>
        {componentParameter.componentTooltip ? (
          <Tippy content={componentParameter.componentTooltip} className="break-words">
            <span
              className={`fas fa-info-circle fill-current ${
                isSelected ? "text-white" : "text-[--bg-color-500]"
              } cursor-pointer text-sm`}
            ></span>
          </Tippy>
        ) : null}
      </div>

      <div className="relative">
        {getDateTimePicker(
          componentParameter.priorDate,
          componentParameter.futureDate
        )}
      </div>
    </div>
  );
};

export const Checkbox = (props) => {
  const {
    componentId,
    componentName,
    isCheckedByDefault,
    isMandatory,
    isSelected,
    isDisabled,
  } = props;
  return (
    <div className="flex items-center space-x-3">
      <input
        id={componentId}
        type="checkbox"
        name={componentName}
        className={`${isSelected && "!outline !outline-white"} form-checkbox`}
        checked={isCheckedByDefault}
      />
      <label
        htmlFor={componentId}
        className={`text-sm font-medium cursor-pointer w-4/5 overflow-hidden truncate ${
          isSelected && "text-white"
        } ${isDisabled && "text-slate-300"}`}
        title={componentName ? componentName : "Label"}
      >
        {componentName ? componentName : "Label"}&nbsp;
        {!isMandatory ? null : <span className="text-rose-500">*</span>}
      </label>
    </div>
  );
};

export const Toggle = (props) => {
  const {
    componentId,
    componentName,
    isCheckedByDefault,
    isMandatory,
    isSelected,
    isDisabled,
  } = props;
  return isCheckedByDefault ? (
    <div className="flex items-center space-x-3">
      <div className="form-switch">
        <input
          id={componentId}
          type="checkbox"
          name={componentName}
          checked={isCheckedByDefault}
          className="sr-only"
        />
        <label htmlFor={componentId} className="bg-slate-400">
          <span className="bg-white shadow-sm" aria-hidden="true"></span>
        </label>
      </div>
      <h6
        className={`text-sm font-medium tracking-tight leading-3 w-full overflow-hidden truncate ${
          isSelected && "text-white"
        } ${isDisabled && "text-slate-300"}`}
        title={componentName ? componentName : "Label"}
      >
        {componentName ? componentName : "Label"}&nbsp;
        {!isMandatory ? null : <span className="text-rose-500">*</span>}
      </h6>
    </div>
  ) : (
    <div className="flex items-center space-x-3">
      <div className="form-switch">
        <input
          id={componentId}
          type="checkbox"
          name={componentName}
          checked={false}
          className="sr-only"
        />
        <label htmlFor={componentId} className="bg-slate-400">
          <span className="bg-white shadow-sm" aria-hidden="true"></span>
        </label>
      </div>
      <h6
        className={`text-sm font-medium tracking-tight leading-3 w-full overflow-hidden truncate ${
          isSelected && "text-white"
        } ${isDisabled && "text-slate-300"}`}
        title={componentName ? componentName : "Label"}
      >
        {componentName ? componentName : "Label"}&nbsp;
        {!isMandatory ? null : <span className="text-rose-500">*</span>}
      </h6>
    </div>
  );
};

export const RadioButton = (props) => {
  const {
    componentName,
    dropdownOptions,
    isSelected,
    isMandatory,
    isDisabled,
    listSelectedValue,
    setComponentParameter
  } = props;
  return (
    <div className="w-full h-full pt-6">
      <h6
        title={componentName ? componentName : "Component Name"}
        className={`block text-sm font-medium mb-1 w-full overflow-hidden truncate ${
          isSelected && "text-white"
        } ${isDisabled && "text-slate-300"}`}
      >
        {componentName ? componentName : "Component Name"}&nbsp;
        {!isMandatory ? null : <span className="text-rose-500">*</span>}
      </h6>
      <div className="space-y-1 flex flex-wrap items-baseline flex-start">
        {dropdownOptions.map((item, index) => (
          <div key={index} className="flex items-center flex-grow">
            <input
              type="radio"
              id={`option${index}`}
              name={`option${index}`}
              className="h-4 w-4 border-gray-300 form-radio"
              onChange={(e) => {
                setComponentParameter(prev => {
                  return {
                    ...prev,
                    listSelectedValue: item
                  }
                })
              }}
              checked={item.value === listSelectedValue?.value}
            />
            <label
              htmlFor={`option${index}`}
              className={`text-sm font-medium tracking-tight ml-2 leading-3 cursor-pointer overflow-hidden truncate ${
                isSelected && "text-white"
              } ${isDisabled && "text-slate-300"}`}
              title={item.label ? item.label : `item ${index + 1}`}
            >
              {item.label ? item.label : `item ${index + 1}`}&nbsp;
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export const Link = (props) => {
  const {
    componentName,
    componentTooltip,
    isMandatory,
    link_url,
    isSelected,
    isDisabled,
  } = props;
  return (
    <div className="flex-1 cursor-pointer space-y-1">
      <div className="bg-white h-9 border first:rounded flex justify-between items-center px-2">
        <h6
          title={componentName ? componentName : "Component Name"}
          className={`text-[13px] leading-5 tracking-tight font-semibold ${
            isDisabled ? "text-[--bg-color-300]" : "text-[--bg-color-500]"
          } w-full overflow-hidden truncate`}
        >
          {componentName ? componentName : "Component Name"}&nbsp;
          {!isMandatory ? null : <span className="text-rose-500">*</span>}
        </h6>
        <a href={link_url} target="_blank" className="block space-x-2">
          {!componentTooltip ? null : (
            <Tippy content={componentTooltip} className="break-words">
              <span
                className={`fas fa-info-circle fill-current ${
                  isDisabled ? "text-[--bg-color-300]" : "text-[--bg-color-500]"
                } cursor-pointer text-sm`}
              ></span>
            </Tippy>
          )}
          <span
            className={`fas fa-link ${
              isDisabled ? "text-[--bg-color-300]" : "text-[--bg-color-500]"
            } text-[13px]`}
          ></span>
        </a>
      </div>
    </div>
  );
};
